import SearchBox from "../components/SearchBox";
import ResultsPageSubHeader from "../components/ResultsPageSubHeader";
import FilterDesktop from "../components/FilterDesktop";
import { Link } from "react-router-dom";
import { T } from "@tolgee/react";
import ResultsDisplay from "../components/ResultsDisplay";
import LoadingIndicator from "../components/LoadingIndicator";
import { useFilter } from "../hooks/useFilter";
import useAppState from "../store/appState";
import Overlay from "../components/Overlay";
import CompanySelection from "../components/CompanySelection";
import { useState } from "react";

const pdfFiles = [
  { productTitle: "TJHT F300/F200", title: "CPR-0673 Range confirmation_signed", fileName: "CPR-0673 Range confirmation_signed.pdf" },
  { productTitle: "IFHT F300/F200", title: "CPR-1085 Range confirmation_signed", fileName: "CPR-1085 Range confirmation_signed.pdf" },
  { productTitle: "IFHT F400", title: "CPR-1250 Range confirmation_signed", fileName: "CPR-1250 Range confirmation_signed.pdf" },
  { productTitle: "TJHU F300/F200", title: "CPR-1422 Range confirmation_signed", fileName: "CPR-1422 Range confirmation_signed.pdf" },
  { productTitle: "TJHU F400", title: "CPR-1481 Range confirmation_signed", fileName: "CPR-1481 Range confirmation_signed.pdf" },
  { productTitle: "THGT F300/F200", title: "CPR-6213 Range confirmation_signed", fileName: "CPR-6213 Range confirmation_signed.pdf" },
  { productTitle: "THGT F400 & CHGT F400", title: "CPR-6216 Range confirmation_signed", fileName: "CPR-6216 Range confirmation_signed.pdf" },
  { productTitle: "TJHT F400", title: "CPR-6239 Range confirmation_signed", fileName: "CPR-6239 Range confirmation_signed.pdf" },
  { productTitle: "CHGT F300/F200", title: "CPR-8019 Range confirmation_signed", fileName: "CPR-8019 Range confirmation_signed.pdf" },
];

function ExtraCertificates() {
  return (
    <div className="bg-white" style={{ width: 500, margin: "25px auto" }}>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {pdfFiles.map((pdf) => {
          const downloadUrl = pdf.url || `/pdfs/${pdf.fileName}`;

          return (
            <li
              key={pdf.fileName}
              style={{
                padding: "1rem",
                borderBottom: "1px solid #eee",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <h3>
                  <strong>{pdf.productTitle}</strong>
                </h3>
                <span>{pdf.title}</span>
              </div>

              <a
                href={downloadUrl}
                download={pdf.fileName} // suggests filename
                style={{
                  padding: "0.6rem 1.2rem",
                  background: "#000",
                  color: "white",
                  borderRadius: "6px",
                  textDecoration: "none",
                }}
              >
                Download PDF
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ExtraCertificates;
